import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition } from "@mcurros2/microm";

const columns = () =>
(
    {
        c_grupoempresa_id: new EntityColumn<string>({ name: 'c_grupoempresa_id', type: 'char', length: 20, flags: c.PK, prompt: 'Grupo ID' }),
        c_cadena_id: new EntityColumn<string>({ name: 'c_cadena_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cadena ID' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        geca_brwStandard: { name: 'geca_brwStandard', keyMappings: { c_cadena_id: 0 } },
        geca_brwPorGrupo: { name: 'geca_brwPorGrupo', keyMappings: { c_cadena_id: 0 } }
    }
)

export class GruposEmpresasCadenasDef extends EntityDefinition {

    columns = columns();
    views = views();

    constructor() {
        super('GruposEmpresasCadenas');
    }
}